import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/download-xls.svg";
var DownloadXlsSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  DownloadXlsSolid_default as default
};
